/** IDs canônicos de db_dfe.status_documento expostos pelos contratos públicos. */
export enum StatusDocumentoEnum {
  Desconhecido = 0,
  TransmissaoPendente = 1,
  Transmitido = 2,
  TransmissaoParalisada = 3,
  Autorizado = 4,
  Rejeitado = 5,
  Denegado = 6,
  Cancelado = 7,
  Inutilizado = 8,
  EmitidoEmContingencia = 9,
  Substituido = 10,
  Inexistente = 11
}
